module.exports = __webpack_public_path__ + "img/scoresheet.8399d12a.png";